import { z } from '@/utils/zod'

import { LanguageSchema, Language } from './Locale'

export type MultilingualText = Partial<Record<Language, string>>

export const createMultilingualTextSchema = (maxLength: number) =>
    z.partialRecord(LanguageSchema, z.string().min(1).max(maxLength))
